// @flow
import { get } from "lodash";

export default (
  { resourceDataAccessor }: { resourceDataAccessor?: string } = {},
  data?: Object = {}
  // schema?: Object = {}
) => get(data, resourceDataAccessor, "");
